<template>
  <div class="test-card" @click="CardClick">
    <div class="book-background">
      <slot name="textImg">
        <img
          :class="props.info.img_type === 2 ? 'bigwidth' : ''"
          width="80px"
          v-complete:src="props.info.img_url"
        />
        <!-- <img width="119px" height="159px" v-complete:src="props.info.img_url" /> -->
      </slot>
    </div>
    <p class="box-price">
      {{ props.info.price === 0 ? "暂无定价" : props.info.price }}
    </p>
    <!-- <el-tooltip effect="light" :content="props.info.title" placement="top"> -->
    <p class="box-content">
      <!-- 模拟试题汇编·考前精选卷模拟试题汇编·考前精选卷121212 -->
      {{ props.info.title }}
    </p>
    <!-- </el-tooltip> -->
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();

const mydata = reactive({
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const props = defineProps({
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
  path: {
    type: String,
    default: "",
  },
});

// 卡片点击
function CardClick() {
  router.push({
    path: props.path,
    query: {
      id: props.info.id,
    },
  });
}
</script>

<style scoped lang="scss">
.test-card {
  width: 166px;
  height: 265px;
  // border:1px solid red;
  background-color: #ffffff;
  padding: 14px;
  // margin-bottom: 32px;
  border-radius: 8px;

  cursor: pointer;

  .book-background {
    width: 139px;
    height: 139px;
    // border:1px solid rgb(119, 255, 0);
    background-color: #eeeeee;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    // img{
    //     display: block;
    //     width:192px;
    //     height:192px;
    //     border:1px solid rgb(0, 17, 255);

    // }
  }
  > p:nth-of-type(1) {
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    color: #ff1a1a;
    margin-top: 14px;
    margin-bottom: 12px;
  }
  > p:nth-of-type(2) {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #333333;

    //height:48px;
    line-height: 24px;
    display: -webkit-box;
    -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
    text-overflow: ellipsis; //文本溢出 用省略号显示
    -webkit-line-clamp: 2; //几行
    overflow: hidden;
  }

  .box-content:hover{
    color:#009de0;
  }
}
</style>
